import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { loadVolumeYears } from '../data/volumes.js';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [volumesOpen, setVolumesOpen] = useState(false);
    const [years, setYears] = useState([]);

    // Only the volume index is needed here, not the articles. It is cached
    // after the first fetch, so remounting the header on each route is free.
    useEffect(() => {
        let active = true;
        loadVolumeYears()
            .then((list) => {
                if (active) setYears(list);
            })
            .catch(() => {
                if (active) setYears([]);
            });
        return () => {
            active = false;
        };
    }, []);

    // Close the mobile drawer whenever the viewport grows back to desktop size,
    // and lock body scroll while the drawer is open.
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) {
                setMenuOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [menuOpen]);

    const closeMenu = () => {
        setMenuOpen(false);
        setVolumesOpen(false);
    };

    const toggleMenu = () => setMenuOpen((open) => !open);

    const linkClass = ({ isActive }) => (isActive ? 'active' : '');

    return (
        <header className="header-section">
            <div className="container">
                <div className="header-inner">
                    <div className="logo">
                        <NavLink to="/home" onClick={closeMenu}>
                            <p>e-JAAM</p>
                            <span className="e-isnn">e-ISSN 2544-9990</span>
                        </NavLink>
                    </div>

                    <button
                        className={`mobile-menu-toggle ${menuOpen ? 'is-active' : ''}`}
                        onClick={toggleMenu}
                        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                        aria-expanded={menuOpen}
                        aria-controls="primary-navigation"
                    >
                        <span className="hamburger-box">
                            <span className="hamburger-line"></span>
                            <span className="hamburger-line"></span>
                            <span className="hamburger-line"></span>
                        </span>
                    </button>

                    <div
                        className={`nav-backdrop ${menuOpen ? 'is-visible' : ''}`}
                        onClick={closeMenu}
                        aria-hidden="true"
                    ></div>

                    <nav
                        id="primary-navigation"
                        className={`nav-menu ${menuOpen ? 'is-open' : ''}`}
                        aria-label="Primary"
                    >
                        <div className="nav-menu-header">
                            <span className="nav-menu-title">Menu</span>
                            <button
                                className="nav-close"
                                onClick={closeMenu}
                                aria-label="Close menu"
                            >
                                &times;
                            </button>
                        </div>
                        <ul className="mainmenu">
                            <li>
                                <NavLink to="/" end className={linkClass} onClick={closeMenu}>
                                    Home
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/aims-and-scopes" className={linkClass} onClick={closeMenu}>
                                    Aims &amp; Scopes
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/editorial" className={linkClass} onClick={closeMenu}>
                                    Editorial
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/abstract-and-indexing" className={linkClass} onClick={closeMenu}>
                                    Abstract &amp; Indexing
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/ethics" className={linkClass} onClick={closeMenu}>
                                    Ethics
                                </NavLink>
                            </li>
                            <li className={`has-dropdown ${volumesOpen ? 'is-open' : ''}`}>
                                <button
                                    type="button"
                                    className="volumes-toggle"
                                    onClick={() => setVolumesOpen((open) => !open)}
                                    aria-expanded={volumesOpen}
                                >
                                    Volumes
                                    <span className="caret" aria-hidden="true"></span>
                                </button>
                                <ul className="volumes-dropdown">
                                    {years.map((year) => (
                                        <li key={year}>
                                            <NavLink to={`/volumes/${year}`} onClick={closeMenu}>
                                                {year}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li>
                                <NavLink to="/submit" className={linkClass} onClick={closeMenu}>
                                    Submit
                                </NavLink>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default Header;
